<script>
    import {Bar} from 'vue-chartjs'
    export default {
        props:["data","option"],
        name: "Bar",
        extends: Bar,
        mounted() {
            this.renderChart(this.data, this.option)
        }
    }
</script>

<style scoped>

</style>